import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';

import { ItensTabelaPlanejamento } from '../../base/util/itens-tabela-planejamento';
import { ItensTratamentoForm } from '../../base/util/itens-tratamento-form';
import { FormularioOrtodontia } from '../../base/vo/formulario-ortodontia';
import { TabelaPlanejamentoComponent } from '../../tabela-planejamento/tabela-planejamento.component';


@Component({
  selector: 'app-primeira-ortodontia-passo-2',
  templateUrl: './primeira-ortodontia-passo-2.component.html',
  styleUrls: ['./primeira-ortodontia-passo-2.component.css']
})
export class PrimeiraOrtodontiaPasso2Component implements OnInit {

  @ViewChild('tabela') tabela: TabelaPlanejamentoComponent;
  @Input() formularioOrtodontia: FormularioOrtodontia;
  @Output() btnProximoEvent = new EventEmitter();

  public itensTratamento: FormGroup;
  @ViewChild('f') passo2Form: NgForm;

  //Para app anexar
  @Input() codigoBeneficiario: string;
  @Input() codigoPrestadorExecutante: string;
  @Input() anexos: any;

  private fieldList = {
    biprotrusao: 'biprotrusao',
    apinhamento: [
      'apinhamento',
      'txtApinhamento',
    ],
    diastemas: [
      'diastemas',
      'txtDiastemas',
    ],
    mordidaAberta: [
      'mordidaAberta',
      'txtMordidaAberta',
    ],
    mordidaCruzada: [
      'mordidaCruzada',
      'mordidaCruzada',
    ],
    mordidaProfunda: 'mordidaProfunda',
    sobresaliencia: 'sobresaliencia',
    diagnosticoOutros: [
      'apinhamento',
      'txtDiagnosticoOutros',
    ],
  }

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.itensTratamento = this.fb.group({
      itensTratamentoForm: this.fb.group(ItensTratamentoForm.getForm())
    });
  }

  public atualizarFormulario(event) {
    this.tabela.atualizarTabela(event);
  }

  public checkEvent(nomeCheck, nomeInput, form) {
    this.addOuRemoverObrigatoriedade(nomeInput, form);
    this.limparInput(nomeCheck, nomeInput);
  }

  private addOuRemoverObrigatoriedade(nomeInput, form) {
    form.control.get(nomeInput).setValidators([Validators.required]);
    form.control.get(nomeInput).markAsTouched();
  }

  private limparInput(nomeCheck, nomeInput) {
    setTimeout(() => {
      if (!this.formularioOrtodontia[nomeCheck]) {
        this.formularioOrtodontia[nomeInput] = '';
      }
    });
  }

  private criarCopiaObjeto(obj: {}): {} {
    return Object.assign({}, obj);
  }

  public proximo(form: FormGroup, itensTratamentoForm: FormGroup, e: Event) {
    e.preventDefault();
    // TODO: utilizar setTouchedValues
    if (form.invalid || itensTratamentoForm.invalid) {
      for (let property in form.controls) {
        form.controls[property].markAsTouched();
      }
      return;
    }
    this.btnProximoEvent.emit();
  }

  public removerItem(item) {
    this.formularioOrtodontia[item.id] = false;
    if (item.inputId) {
      this.limparInput(item.id, item.inputId);
      this.itensTratamento.controls.itensTratamentoForm.get(item.inputId).setValidators([Validators.required]);
      this.itensTratamento.controls.itensTratamentoForm.get(item.inputId).markAsUntouched();
      this.itensTratamento.controls.itensTratamentoForm.get(item.inputId).disable();
    }
  }

  public isBtnDisabled(form: FormGroup, itensTratamentoForm: FormGroup): boolean {
    if (form.invalid ||
      itensTratamentoForm.invalid ||
      !this.isValidAnexos() ||
      !this.isDiagnosticoValid() ||
      !this.isPlanejamentoValid()) {
      return true;
    }
    return false;
  }

  private isValidAnexos(): boolean {
    //Checar anexos tratamento
    if (!this.isValidAnexosIncluidos(this.anexos)) {
      return false;
    }

    return true;
  }

  private isValidAnexosIncluidos(anexos): boolean {
    if (anexos && anexos.length > 0) {
      for (let i = 0; i < anexos.length; i++) {
        if (anexos[i].isInvalidTipo || anexos[i].isInvalidSituacao) {
          return false;
        }
      }
    }
    return true;
  }

  private isDiagnosticoValid(): boolean {
    return Object.keys(this.fieldList).some(key => {
      if (typeof this.fieldList[key] === 'string') {
        return !!this.formularioOrtodontia[key];
      }

      if (typeof this.fieldList[key] === 'object') {
        return this.fieldList[key].every((key: string) => this.formularioOrtodontia[key]);
      }
    });
  }


  private isPlanejamentoValid() {
    return ItensTabelaPlanejamento.getItensPlanejamento(this.formularioOrtodontia).some(item => item.visivel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ortodontia/primeira-ortodontia-passo-2/primeira-ortodontia-passo-2.component.ts